
import { defineComponent, computed } from "vue";
import objectPath from "object-path";
import { Actions } from "../../store/enums/StoreEnums";
import { useStore } from "vuex";
import KTUserMenu from "@/layout/header/partials/UserMenu.vue";

export default defineComponent({
  name: "topbar",
  components: {
    KTUserMenu,
  },
  setup() {
    const store = useStore();
    const user = computed(() => store.getters.getUser);
    const op = computed(() => objectPath);
    if (!Object.keys(store.getters.getUser).length)
      store.dispatch(Actions.AUTH_USER);
    return {
      user,
      op,
    };
  },
});
